(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
if (!window.kurvoAnnouncementCouponInstalled) {
  window.kurvoAnnouncementCouponInstalled = true;
  document.addEventListener('click', async function (event) {
    const button = event.target.closest('[data-kurvo-coupon]');
    if (!button || button.disabled) return;
    event.preventDefault();
    event.stopPropagation();
    const code = button.dataset.kurvoCoupon;
    const feedback = button.querySelector('[data-kurvo-coupon-feedback]');
    const codeElement = button.querySelector('[data-kurvo-coupon-code]');
    const focusedElement = document.activeElement;
    button.disabled = true;
    let copied = false;
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(code);
        copied = true;
      }
    } catch (error) {}
    if (!copied) {
      const input = document.createElement('textarea');
      input.value = code;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.left = '-9999px';
      input.style.top = '0';
      document.body.appendChild(input);
      try {
        input.select();
        input.setSelectionRange(0, code.length);
        copied = document.execCommand('copy');
      } catch (error) {}
      input.remove();
      if (focusedElement && focusedElement.isConnected) focusedElement.focus({preventScroll: true});
    }
    button.disabled = false;
    feedback.textContent = copied ? button.dataset.copiedLabel : button.dataset.errorLabel;
    if (!copied && codeElement) {
      const range = document.createRange();
      range.selectNodeContents(codeElement);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
    }
    window.clearTimeout(button.kurvoCouponReset);
    button.kurvoCouponReset = window.setTimeout(function () {
      if (button.isConnected) feedback.textContent = button.dataset.copyLabel;
    }, 2500);
  });
}

  } catch(e) { console.error(e); }
})();
})();
